import React from 'react';
import { render, hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';

import store from './store/store';
import history from './store/history';
import Routes from '../router/Routes';

hydrate(
  <Provider store={store}>
    <MuiThemeProvider>
      <Router>
        <Routes />
      </Router>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./source/client/client.jsx